import React from 'react';
import { ROUTE_LINKS } from '../data/routePages';

// The words under the rate explorer on a direct visit to /quote/: how quoting
// works, what is compared, and the questions people ask before booking. Shown
// only before a quote exists, never above the booking steps.
const STEPS = [
  ['Tell us about the parcel', 'Choose the destination and enter the weight. Add the box size for an exact price: couriers charge on the higher of the actual and volumetric weight.'],
  ['Compare every service', 'See the live price and typical transit time for each service on the route, cheapest first.'],
  ['Book online', 'Pick a service, add the addresses, choose door pickup or free drop-off at our Delhi office, and pay online.'],
];

const FAQ = [
  ['Do I need an account to get a quote?', 'No. You can compare prices without signing in; you create an account only when you are ready to pay and book.'],
  ['How is the price calculated?', 'On the chargeable weight — the higher of the actual weight and the volumetric weight (length × width × height in cm ÷ 5000) — the destination and the service you choose.'],
  ['Is customs duty included?', 'No, unless you choose a DDP (duty paid) service. Otherwise any import duty or tax is usually paid by the recipient in the destination country.'],
  ['Can you collect the parcel from my home?', 'Yes. Door pickup is priced by your PIN code, or you can drop the parcel at our office in Mahipalpur, New Delhi, for free.'],
];

const QuotePageInfo = () => (
  <div className="space-y-10 rounded-2xl bg-white p-6 sm:p-8 shadow-sm" data-test="quote-info">
    <section>
      <h2 className="text-2xl font-bold text-slate-900 mb-4">How getting a quote works</h2>
      <ol className="grid gap-4 md:grid-cols-3">
        {STEPS.map(([title, text], i) => (
          <li key={title} className="rounded-xl border border-slate-200 p-4">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-orange-500 text-sm font-bold text-white">{i + 1}</span>
            <p className="mt-3 font-semibold text-slate-900">{title}</p>
            <p className="mt-1 text-sm text-slate-600">{text}</p>
          </li>
        ))}
      </ol>
    </section>

    <section>
      <h2 className="text-2xl font-bold text-slate-900 mb-3">Carriers we compare</h2>
      <p className="text-slate-600 leading-relaxed">
        {'Depending on the route, your quote compares DHL and FedEx express, UPS, India Post Speed Post (EMS) and Air Parcel, '
          + 'and SendMyParcel’s own services — including duty-paid (DDP) options on routes such as the UK, USA and Canada. '
          + 'No single carrier is cheapest everywhere: the best price changes with the destination, the weight and how fast you need it.'}
      </p>
      <p className="mt-3 text-sm text-slate-600">
        {'Rates and transit times by weight: '}
        {['uk', 'usa', 'canada', 'australia', 'europe'].map((k, i) => (
          <React.Fragment key={k}>
            {i > 0 && ' · '}
            <a href={ROUTE_LINKS[k].href} className="text-orange-600 font-medium hover:underline">{ROUTE_LINKS[k].label}</a>
          </React.Fragment>
        ))}
        {' · '}
        <a href="/shipping-rates-calculator/" className="text-orange-600 font-medium hover:underline">Shipping calculator</a>
      </p>
    </section>

    <section>
      <h2 className="text-2xl font-bold text-slate-900 mb-4">Questions before you book</h2>
      <div className="space-y-5">
        {FAQ.map(([q, a]) => (
          <div key={q}>
            <h3 className="font-semibold text-slate-900">{q}</h3>
            <p className="mt-1 text-slate-600">{a}</p>
          </div>
        ))}
      </div>
    </section>
  </div>
);

export default QuotePageInfo;
